//@ts-nocheck
import React from 'react';
import classNames from 'classnames';

import { T } from '@web-solutions/module-localization';

import { useRemoteConfig } from 'core/hooks/use-remote-config';

import { ProductDetails } from 'core/store/billing/selectors';
import { Text } from 'core/ui-elements';

import { ReactComponent as Security } from 'core/assets/icons/security.svg';

import classes from './style.module.scss';

export const generateLinkComponents = (links: any) => {
  return Object.keys(links).reduce(
    (acc, key) => {
      acc[key as any] = (
        <a href={links[key]} target='_blank' rel='noopener noreferrer'>
          {key}
        </a>
      );
      return acc;
    },
    {} as Record<number, React.ReactNode>
  );
};

export type Placements =
  | 'in'
  | 'out'
  | 'modal'
  | 'modal-top'
  | 'upsale-payment-modal-bottom'
  | 'subs-payment-modal-bottom';

interface Props {
  activeProduct?: ProductDetails;
  isShort?: boolean;
  className?: string;
  placement?: Placements;
}

const PaymentDescription: React.FC<Props> = ({ activeProduct, placement = 'in', className }) => {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;

  const product = { ...activeProduct, ...activeProduct?.paymentDescription, supportEmail };

  const { paymentDescription, paymentDescriptionPlacements, policyLinks } = useRemoteConfig();

  const { hint, hintTitle, hintBottom, security, privacy, privacyTitle } = paymentDescription;

  const components = {
    hintTitle: hintTitle && (
      <p className={classes.hintTitle}>
        <T
          k={hintTitle}
          tOptions={product}
          components={{
            supportEmailLink: <a href={`mailto:${supportEmail}`} />,
            ...generateLinkComponents(policyLinks),
            ...(product.showVat && { vat: <span /> }),
          }}
        />
      </p>
    ),
    security: security && (
      <div className={classes.security}>
        <Security />
        <Text variant='p3' tOptions={product}>
          {security}
        </Text>
      </div>
    ),
    hint: hint && (
      <Text
        className={classes.hintText}
        tOptions={product}
        components={{
          supportEmailLink: <a href={`mailto:${supportEmail}`} />,
          ...generateLinkComponents(policyLinks),
          ...(product.showVat && { vat: <span /> }),
        }}
      >
        {hint}
      </Text>
    ),
    hintBottom: hintBottom && (
      <p className={classNames(classes.hintText, classes.bottom)}>
        <T
          k={hintBottom}
          tOptions={product}
          components={{
            supportEmailLink: <a href={`mailto:${supportEmail}`} />,
            ...generateLinkComponents(policyLinks),
            ...(product.showVat && { vat: <span /> }),
          }}
        />
      </p>
    ),
    privacy: privacy && (
      <Text
        className={classes.hintText}
        tOptions={product}
        components={{
          supportEmailLink: <a href={`mailto:${supportEmail}`} />,
          ...generateLinkComponents(policyLinks),
          ...(product.showVat && { vat: <span /> }),
        }}
      >
        {privacy}
      </Text>
    ),
    privacyTitle: privacyTitle && null,
  };

  const placements = paymentDescriptionPlacements?.[placement];

  if (!placements?.length) {
    return <></>;
  }

  return (
    <div className={classNames(classes.hint, className)}>
      {placements.map((i) => (
        <React.Fragment key={i}>{components[i]}</React.Fragment>
      ))}
    </div>
  );
};

export default PaymentDescription;
